import React from 'react'
import { Button } from '@material-ui/core'

const ExternalLinkButton = React.forwardRef(function ExternalLinkButton(
  { children, ...props },
  ref,
) {
  return (
    <Button
      {...props}
      target={props.target || '_blank'}
      component="a"
      ref={ref}
    >
      {children}
    </Button>
  )
})

export default ExternalLinkButton
